// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/Hero.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/heroSlideshowImages/2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/images/heroSlideshowImages/3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.hero__logoreplacement {
  text-align: center;
  font-family: Bruney, sans-serif;
  font-size: 1.6rem;
  color: rgb(243, 226, 201);
  padding: 1.3rem 0 0 0;
}
@media (min-width: 450px) {
  .hero__logoreplacement {
    font-size: 2.2rem;
  }
}
@media (min-width: 768px) {
  .hero__logoreplacement {
    padding: 2.2rem 0 0 0;
    font-size: 1.9rem;
  }
}
@media (min-width: 1280px) {
  .hero__logoreplacement {
    font-size: 2.5rem;
    padding: 3.5rem 0 0 0;
  }
}
.hero__logoparent {
  padding-bottom: 1rem;
}
.hero__childmobile {
  margin-top: 2rem;
  background-size: contain;
  background-position: top;
  height: 70%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position-y: 2rem;
  transition: background-image 1s cubic-bezier(0.39, 0.575, 0.565, 1);
  aspect-ratio: 19/10;
}
@media (min-width: 768px) {
  .hero__childmobile {
    display: none;
  }
}
.hero__branding {
  display: flex;
  flex-direction: column;
  max-width: 90%;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
}
@media (min-width: 768px) {
  .hero__branding {
    flex-direction: column;
    padding-top: 0;
  }
}
.hero__logo {
  width: 48vw;
}
@media (min-width: 450px) {
  .hero__logo {
    width: 40vw;
    max-width: 250px;
  }
}
@media (min-width: 768px) {
  .hero__logo {
    width: 8rem;
    display: block;
    margin: auto;
    padding-top: 0.5rem;
    animation-delay: 0.5s;
  }
}
@media (min-width: 1280px) {
  .hero__logo {
    width: 12rem;
    padding-bottom: 1rem;
  }
}
.hero__slogan {
  color: rgb(242, 211, 164);
  text-align: center;
  font-size: 0.7rem;
}
@media (min-width: 450px) {
  .hero__slogan {
    font-size: 1rem;
    padding-bottom: 1rem;
  }
}
@media (min-width: 768px) {
  .hero__slogan {
    font-size: 0.8rem;
  }
}
@media (min-width: 1280px) {
  .hero__slogan {
    font-size: 1.18rem;
  }
}
.hero__about2 {
  padding-left: 5%;
  align-self: center;
  font-size: 0.9rem;
}
@media (min-width: 450px) {
  .hero__about2 {
    font-size: 1rem;
  }
}
@media (min-width: 600px) {
  .hero__about2 {
    font-size: 1.2rem;
  }
}
@media (min-width: 768px) {
  .hero__about2 {
    padding-top: 0;
    font-size: 0.8rem;
  }
}
@media (min-width: 1280px) {
  .hero__about2 {
    font-size: 1rem;
  }
}
.hero__about3 {
  padding-top: 2rem;
  font-size: 1.2rem;
  width: 60%;
  margin: auto;
}
@media (min-width: 768px) {
  .hero__about3 {
    padding-top: 2rem;
    font-size: 1.2rem;
  }
}
.hero__about4 {
  color: white;
  font-size: 0.9rem;
  width: 60%;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin: auto;
  text-align: center;
}
@media (min-width: 768px) {
  .hero__about4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
.hero__image {
  width: 100%;
  height: 600px;
}
.hero__parent {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .hero__parent {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    margin-top: 2.2rem;
    width: 100%;
  }
}
.hero__child1 {
  background-color: #2f020c;
}
@media (min-width: 768px) {
  .hero__child1 {
    height: 25rem;
    width: 35%;
    padding-right: 1rem;
    padding-left: 1rem;
  }
}
@media (min-width: 1280px) {
  .hero__child1 {
    height: 600px;
    padding: 1rem 3rem 2rem 3rem;
    width: 30%;
  }
}
.hero__image0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.hero__image1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.hero__image2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.hero__child2 {
  display: none;
}
@media (min-width: 768px) {
  .hero__child2 {
    transition: background-image 1s cubic-bezier(0.39, 0.575, 0.565, 1);
    z-index: -99;
    background-size: contain;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position-x: 7rem;
    background-position-y: 1rem;
    height: 25rem;
    width: 65%;
    display: flex;
    justify-content: center;
  }
}
@media (min-width: 920px) {
  .hero__child2 {
    background-position-y: -3rem;
  }
}
@media (min-width: 1000px) {
  .hero__child2 {
    background-position-y: 0rem;
    background-position-x: 15rem;
    background-size: 80%;
  }
}
@media (min-width: 1100px) {
  .hero__child2 {
    background-position-y: -3rem;
    background-position-x: 18rem;
    background-size: 80%;
  }
}
@media (min-width: 1130px) {
  .hero__child2 {
    background-position-y: -3rem;
    background-position-x: 18rem;
    background-size: 80%;
  }
}
@media (min-width: 1240px) {
  .hero__child2 {
    background-position-y: -3rem;
    background-position-x: 20rem;
    background-size: 77%;
  }
}
@media (min-width: 1280px) {
  .hero__child2 {
    width: 70%;
    height: 600px;
    background-size: 85%;
    background-position-y: 2rem;
    background-position-x: 20rem;
    background-repeat: no-repeat;
    background-attachment: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (min-width: 1290px) {
  .hero__child2 {
    background-position-y: 2rem;
    background-position-x: 20rem;
    background-size: 85%;
  }
}
@media (min-width: 1350px) {
  .hero__child2 {
    background-position-y: 1rem;
    background-position-x: 20rem;
    background-size: 80%;
  }
}
@media (min-width: 1550px) {
  .hero__child2 {
    background-position-y: -5rem;
    background-position-x: 28rem;
    background-size: 75%;
  }
}
.hero__about1 {
  padding-top: 0.5rem;
  line-height: 2rem;
  word-spacing: 30px;
  padding-bottom: 0.2rem;
}
.hero__formtitle {
  color: white;
  font-weight: 400;
  font-size: 1.1rem;
  text-align: center;
  padding-bottom: 1rem;
}
@media (min-width: 450px) {
  .hero__formtitle {
    font-size: 170%;
    padding-bottom: 1.5rem;
  }
}
@media (min-width: 768px) {
  .hero__formtitle {
    font-size: 1rem;
    padding-bottom: 0.9rem;
  }
}
@media (min-width: 1280px) {
  .hero__formtitle {
    padding-top: 1rem;
    font-size: 1.3rem;
  }
}
.hero__form {
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: auto;
  max-width: 400px;
}
@media (min-width: 768px) {
  .hero__form {
    width: 90%;
  }
}
.hero__form--parent {
  display: flex;
  flex-direction: row;
}
.hero__form--name, .hero__form--email, .hero__form--phone, .hero__form--city {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  border: none;
  font-family: Nexa;
  font-weight: 400;
  background-color: rgb(235, 234, 234);
}
@media (min-width: 450px) {
  .hero__form--name, .hero__form--email, .hero__form--phone, .hero__form--city {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 0.9rem;
  }
}
@media (min-width: 768px) {
  .hero__form--name, .hero__form--email, .hero__form--phone, .hero__form--city {
    height: 3.5vh;
  }
}
@media (min-width: 1280px) {
  .hero__form--name, .hero__form--email, .hero__form--phone, .hero__form--city {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 0.9rem;
  }
}
.hero__form--name {
  margin-right: 0.5rem;
}
.hero__form--name, .hero__form--city {
  width: 50%;
}
.hero__form--message {
  padding-top: 0.25rem;
  padding-bottom: 4rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  border: none;
  font-family: Nexa;
  font-weight: 400;
  color: gray;
  background-color: rgb(235, 234, 234);
}
@media (min-width: 768px) {
  .hero__form--message {
    padding-bottom: 1rem;
  }
}
@media (min-width: 1280px) {
  .hero__form--message {
    padding-bottom: 3rem;
  }
}
.hero__form--button {
  font-family: Nexa;
  margin-top: 0.1rem;
  border-radius: 6px;
  height: 5vh;
  width: 100%;
  background-color: rgb(181, 144, 88);
  color: white;
}
@media (min-width: 768px) {
  .hero__form--button {
    height: 4vh;
  }
}
@media (min-width: 1280px) {
  .hero__form--button {
    height: 5vh;
    text-align: center;
    font-size: 0.9rem;
  }
}
.hero__brandname {
  font-size: 2rem;
  font-weight: 400;
}
.hero__brandname, .hero__about1, .hero__about2, .hero__about3 {
  color: white;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/components/Hero/Hero.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_variables.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAjFI;EACI,kBAAA;EACA,+BAAA;EACA,iBAAA;EACA,yBEGU;EFFV,qBAAA;AAoFR;AAnFQ;EANJ;IAOQ,iBAAA;EAsFV;AACF;AGjGI;EHGA;IAUQ,qBAAA;IACA,iBAAA;EAwFV;AACF;AGlGI;EHFA;IAcQ,iBAAA;IACA,qBAAA;EA0FV;AACF;AAxFI;EACI,oBAAA;AA0FR;AAxFI;EACI,gBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,mEAAA;EACA,mBAAA;AA0FR;AG3HI;EHwBA;IAWQ,aAAA;EA4FV;AACF;AA1FI;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AA4FR;AGxII;EHsCA;IAQQ,sBAAA;IACA,cAAA;EA8FV;AACF;AA5FI;EACI,WAAA;AA8FR;AA7FQ;EAFJ;IAGQ,WAAA;IACA,gBAAA;EAgGV;AACF;AGvJI;EHkDA;IAOQ,WAAA;IACA,cAAA;IACA,YAAA;IACA,mBAAA;IACA,qBAAA;EAkGV;AACF;AG3JI;EH6CA;IAcQ,YAAA;IACA,oBAAA;EAoGV;AACF;AAlGI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;AAoGR;AAnGQ;EAJJ;IAKQ,eAAA;IACA,oBAAA;EAsGV;AACF;AGjLI;EHoEA;IASQ,iBAAA;EAwGV;AACF;AGjLI;EH+DA;IAYQ,kBAAA;EA0GV;AACF;AAxGI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AA0GR;AGrLI;EHwEA;IAKQ,eAAA;EA4GV;AACF;AA3GQ;EAPJ;IAQQ,iBAAA;EA8GV;AACF;AG1MI;EHmFA;IAWQ,cAAA;IACA,iBAAA;EAgHV;AACF;AG3MI;EH8EA;IAeQ,eAAA;EAkHV;AACF;AAhHI;EACI,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AAkHR;AG3NI;EHqGA;IAMQ,iBAAA;IACA,iBAAA;EAoHV;AACF;AAlHI;EACI,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAoHR;AG1OI;EH+GA;IASQ,iBAAA;IACA,oBAAA;EAsHV;AACF;AApHI;EACI,WAAA;EACA,aAAA;AAsHR;AApHI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAsHR;AGzPI;EHgIA;IAKQ,oBAAA;IACA,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;EAwHV;AACF;AAtHI;EACI,yBErIU;AF6PlB;AGrQI;EH4IA;IAGQ,aAAA;IACA,UAAA;IACA,mBAAA;IACA,kBAAA;EA0HV;AACF;AGxQI;EHuIA;IASQ,aAAA;IACA,4BAAA;IACA,UAAA;EA4HV;AACF;AA1HI;EACI,0DAAA;AA4HR;AA1HI;EACI,0DAAA;AA4HR;AA1HI;EACI,0DAAA;AA4HR;AA1HI;EACI,aAAA;AA4HR;AGhSI;EHmKA;IAGQ,mEAAA;IACA,YAAA;IACA,wBAAA;IACA,4BAAA;IACA,4BAAA;IACA,2BAAA;IACA,2BAAA;IACA,aAAA;IACA,UAAA;IACA,aAAA;IACA,uBAAA;EA8HV;AACF;AA7HQ;EAfJ;IAgBQ,4BAAA;EAgIV;AACF;AA/HQ;EAlBJ;IAmBQ,2BAAA;IACA,4BAAA;IACA,oBAAA;EAkIV;AACF;AAjIQ;EAvBJ;IAwBQ,4BAAA;IACA,4BAAA;IACA,oBAAA;EAoIV;AACF;AAnIQ;EA5BJ;IA6BQ,4BAAA;IACA,4BAAA;IACA,oBAAA;EAsIV;AACF;AArIQ;EAjCJ;IAkCQ,4BAAA;IACA,4BAAA;IACA,oBAAA;EAwIV;AACF;AG3UI;EH8JA;IAuCQ,UAAA;IACA,aAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;IACA,4BAAA;IACA,4BAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EA0IV;AACF;AAzIQ;EAlDJ;IAmDQ,2BAAA;IACA,4BAAA;IACA,oBAAA;EA4IV;AACF;AA3IQ;EAvDJ;IAwDQ,2BAAA;IACA,4BAAA;IACA,oBAAA;EA8IV;AACF;AA7IQ;EA5DJ;IA6DQ,4BAAA;IACA,4BAAA;IACA,oBAAA;EAgJV;AACF;AA9II;EACI,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAgJR;AA9II;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAgJR;AGrXI;EHgOA;IAOQ,eAAA;IACA,sBAAA;EAkJV;AACF;AGtYI;EH2OA;IAWQ,eAAA;IACA,sBAAA;EAoJV;AACF;AGvYI;EHsOA;IAeQ,iBAAA;IACA,iBAAA;EAsJV;AACF;AApJI;EACI,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAsJR;AG1ZI;EH8PA;IAQQ,UAAA;EAwJV;AACF;AAvJQ;EACI,aAAA;EACA,mBAAA;AAyJZ;AAvJQ;EACI,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AAyJZ;AGnaI;EHiQI;IAWQ,mBAAA;IACA,sBAAA;IACA,iBAAA;EA2Jd;AACF;AGrbI;EH4QI;IAgBQ,aAAA;EA6Jd;AACF;AGrbI;EHuQI;IAmBQ,iBAAA;IACA,oBAAA;IACA,iBAAA;EA+Jd;AACF;AA7JQ;EACI,oBAAA;AA+JZ;AA7JQ;EACI,UAAA;AA+JZ;AA7JQ;EACI,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AA+JZ;AGndI;EH0SI;IAYQ,oBAAA;EAiKd;AACF;AGndI;EHqSI;IAeQ,oBAAA;EAmKd;AACF;AAjKQ;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,YAAA;AAmKZ;AGteI;EH4TI;IASQ,WAAA;EAqKd;AACF;AGteI;EHuTI;IAYQ,WAAA;IACA,kBAAA;IACA,iBAAA;EAuKd;AACF;AApKI;EACI,eAAA;EACA,gBAAA;AAsKR;AApKI;EACI,YAAA;EACA,kBAAA;AAsKR","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.hero{\n    &__logoreplacement{\n        text-align: center;\n        font-family: Bruney, sans-serif;\n        font-size: 1.6rem;\n        color: $xeus-lightbeige;\n        padding: 1.3rem 0 0 0;\n        @media (min-width: 450px) {\n            font-size: 2.2rem;\n        }\n        @include tablet-and-desktop{\n            padding: 2.2rem 0 0 0;\n            font-size: 1.9rem;\n        }\n        @include desktop{\n            font-size: 2.5rem;\n            padding: 3.5rem 0 0 0;\n        }\n    }\n    &__logoparent{\n        padding-bottom: 1rem;\n    }\n    &__childmobile{\n        margin-top: 2rem;\n        background-size: contain;\n        background-position: top;\n        height: 70%;\n        background-repeat: no-repeat;\n        background-attachment: fixed;\n        background-position-y: 2rem;\n        transition: background-image 1s cubic-bezier(0.39, 0.575, 0.565, 1);\n        aspect-ratio: 19/10;\n        @include tablet-and-desktop{\n            display: none;\n        }\n    }\n    &__branding{\n        display: flex;\n        flex-direction: column;\n        max-width: 90%;\n        margin: auto;\n        padding-top: 1rem;\n        padding-bottom: 1.5rem;\n        @include tablet-and-desktop{\n            flex-direction: column;\n            padding-top: 0;\n        }\n    }\n    &__logo{\n        width: 48vw;\n        @media (min-width: 450px) {\n            width: 40vw;\n            max-width: 250px;\n        }\n        @include tablet-and-desktop{\n            width: 8rem;\n            display: block;\n            margin: auto;\n            padding-top: 0.5rem;\n            animation-delay: 0.5s;\n        }\n        @include desktop{\n            width: 12rem;\n            padding-bottom: 1rem;  \n        }\n    }\n    &__slogan{\n        color: rgb(242, 211, 164);\n        text-align: center;\n        font-size: 0.7rem;\n        @media (min-width: 450px) {\n            font-size: 1rem;\n            padding-bottom: 1rem;\n        }\n        @include tablet-and-desktop{\n            font-size: 0.8rem;\n        }\n        @include desktop{\n            font-size: 1.18rem;\n        }\n            }\n    &__about2{\n        padding-left: 5%;\n        align-self: center;\n        font-size: 0.9rem;\n        @include big-mobile-screen{\n            font-size: 1rem;\n        }\n        @media (min-width: 600px) {\n            font-size: 1.2rem\n        }\n        @include tablet-and-desktop{\n            padding-top: 0;\n            font-size: 0.8rem;\n        }\n        @include desktop{\n            font-size: 1rem;\n        }\n    }\n    &__about3{\n        padding-top: 2rem;\n        font-size: 1.2rem;\n        width: 60%;\n        margin: auto;\n        @include tablet-and-desktop{\n            padding-top: 2rem;\n            font-size: 1.2rem;\n        }\n    }\n    &__about4{\n        color: white;\n        font-size: 0.9rem;\n        width: 60%;\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        margin: auto;\n        text-align: center;\n        @include tablet-and-desktop{\n            padding-top: 1rem;\n            padding-bottom: 1rem;\n        }\n    }\n    &__image{\n        width: 100%;\n        height: 600px;\n    }\n    &__parent{\n        overflow: hidden;\n        display: flex;\n        flex-direction: column;\n        @include tablet-and-desktop{\n            align-items: stretch;\n            display: flex;\n            flex-direction: row;\n            margin-top: 2.2rem;\n            width: 100%;\n        }\n    }\n    &__child1{\n        background-color: $xeus-darkmaroon;\n        @include tablet-and-desktop{\n            height: 25rem;\n            width: 35%;\n            padding-right: 1rem;\n            padding-left: 1rem;\n        }\n        @include desktop{\n            height: 600px;\n            padding: 1rem 3rem 2rem 3rem;\n            width: 30%;\n        }\n    }\n    &__image0{\n        background-image: url('../../assets/images/Hero.png');\n    }\n    &__image1{\n        background-image: url('../../assets/images/heroSlideshowImages/2.jpg');\n    }\n    &__image2{\n        background-image: url('../../assets/images/heroSlideshowImages/3.jpg');\n    }\n    &__child2{\n        display: none;\n        @include tablet-and-desktop{\n            transition: background-image 1s cubic-bezier(0.39, 0.575, 0.565, 1);\n            z-index: -99;\n            background-size: contain;\n            background-repeat: no-repeat;\n            background-attachment: fixed;\n            background-position-x: 7rem;\n            background-position-y: 1rem;\n            height: 25rem;\n            width: 65%;\n            display: flex;\n            justify-content: center;\n        }\n        @media (min-width: 920px) {\n            background-position-y: -3rem;            \n        }\n        @media (min-width: 1000px) {\n            background-position-y: 0rem;\n            background-position-x: 15rem;\n            background-size: 80%;            \n        }\n        @media (min-width: 1100px) {\n            background-position-y: -3rem;\n            background-position-x: 18rem;\n            background-size: 80%;            \n        }\n        @media (min-width: 1130px) {\n            background-position-y: -3rem;\n            background-position-x: 18rem;\n            background-size: 80%;            \n        }\n        @media (min-width: 1240px) {\n            background-position-y: -3rem;\n            background-position-x: 20rem;\n            background-size: 77%;            \n        }\n        @include desktop{\n            width: 70%;\n            height: 600px;\n            background-size: 85%; \n            background-position-y: 2rem;\n            background-position-x: 20rem; \n            background-repeat: no-repeat;\n            background-attachment: fixed;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n        @media (min-width: 1290px) {\n            background-position-y: 2rem;\n            background-position-x: 20rem;\n            background-size: 85%;            \n        }\n        @media (min-width: 1350px) {\n            background-position-y: 1rem;\n            background-position-x: 20rem;\n            background-size: 80%;            \n        }\n        @media (min-width: 1550px) {\n            background-position-y: -5rem;\n            background-position-x: 28rem;\n            background-size: 75%;            \n        }\n    }\n    &__about1{\n        padding-top: 0.5rem;\n        line-height: 2rem;\n        word-spacing: 30px;\n        padding-bottom: 0.2rem;\n    }\n    &__formtitle{\n        color: white;\n        font-weight: 400;\n        font-size: 1.1rem;\n        text-align: center;\n        padding-bottom: 1rem;\n        @include big-mobile-screen{\n            font-size: 170%;\n            padding-bottom: 1.5rem;\n        }\n        @include tablet-and-desktop{\n            font-size: 1rem;\n            padding-bottom: 0.9rem;\n        }\n        @include desktop{\n            padding-top: 1rem;\n            font-size: 1.3rem;\n        }\n    }\n    &__form{\n        padding-bottom: 2rem;\n        display: flex;\n        flex-direction: column;\n        width: 65%;\n        margin: auto;\n        max-width: 400px;\n        @include tablet-and-desktop{\n            width: 90%;\n        }\n        &--parent{\n            display: flex;\n            flex-direction: row;\n        }\n        &--name, &--email, &--phone, &--city {\n            padding-top: 0.25rem;\n            padding-bottom: 0.25rem;\n            padding-left: 1rem;\n            margin-bottom: 0.5rem;\n            border-radius: 6px;\n            border: none;\n            font-family: Nexa;\n            font-weight: 400;\n            background-color: rgb(235, 234, 234);\n            @include big-mobile-screen{\n                padding-top: 0.5rem;\n                padding-bottom: 0.5rem;\n                font-size: 0.9rem;\n            }\n            @include tablet-and-desktop{\n                height: 3.5vh;\n            }\n            @include desktop{\n                padding-top: 1rem;\n                padding-bottom: 1rem;\n                font-size: 0.9rem;\n            }\n        }\n        &--name{\n            margin-right: 0.5rem;\n        }\n        &--name, &--city {\n            width: 50%;\n        }\n        &--message{\n            padding-top: 0.25rem;\n            padding-bottom: 4rem;\n            padding-left: 1rem;\n            margin-bottom: 0.5rem;\n            border-radius: 6px;\n            border: none;\n            font-family: Nexa;\n            font-weight: 400;\n            color: gray;\n            background-color: rgb(235, 234, 234);\n            @include tablet-and-desktop{\n                padding-bottom: 1rem;\n            }\n            @include desktop{\n                padding-bottom: 3rem;\n            }\n        }\n        &--button{\n            font-family: Nexa;\n            margin-top: 0.1rem;\n            border-radius: 6px;\n            height: 5vh;\n            width: 100%;\n            background-color: rgb(181, 144, 88);\n            color: white;\n            @include tablet-and-desktop{\n                height: 4vh;\n            }\n            @include desktop{\n                height: 5vh;\n                text-align: center;\n                font-size: 0.9rem;\n            }\n        }\n    }\n    &__brandname{\n        font-size: 2rem;\n        font-weight: 400;\n    }\n    &__brandname, &__about1, &__about2, &__about3 {\n        color: white;\n        text-align: center;\n    }\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n$max-width: 1195px;\n$mobile-header-fontsize: 1rem;\n$mobile-subheader-fontsize: 0.9rem;\n$mobile-content-fontsize: 0.8rem;\n$text-darkgray: rgb(39, 32, 32);\n$text-shadow: #3d3d3d;\n$button-color: #2f7fb0;\n$button-color-hover: #0c4f76;\n$website-darkgray: rgb(44, 43, 43);\n$xeus-darkmaroon: #2f020c;\n$xeus-mediumbeige: rgb(224, 196, 154);\n$xeus-lightbeige: rgb(243, 226, 201);\n$website-border-lightgray: rgb(238, 234, 234);\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
